// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"23":"registro","312":"blank","368":"confirm","551":"locale-en-json","756":"thanks","790":"locale-es-json"}[chunkId] + "." + {"23":"d3bfb280","312":"6ff394d7","368":"b791a73b","551":"d64d6c2f","756":"5442c0cc","790":"be66b76b"}[chunkId] + ".js";
};